import { AnimatedCollapse } from '@/components/ui/animated-collapse';

export function PrefillHint({ roleName }: { roleName: string | null }) {
  return (
    <AnimatedCollapse open={!!roleName}>
      <p className="text-[10px] sm:text-[12px] font-mono text-muted-foreground/60 text-right overflow-hidden -mt-0.5">
        from {roleName}
      </p>
    </AnimatedCollapse>
  );
}
